$(document).ready(function() {
  $('.js-input-keyword').keypress(function (event) {
    if(event.which === 13){
        var keyword = $(".js-input-keyword").val();
        window.location.href = Routes.articles_path({ keyword: keyword })
        return false;
    }
  });

  $(".js-btn-clear-input").on("click", function (event) {
    event.preventDefault()
    $(".js-input-keyword").val("").focus();
    $(".icon_clear").addClass('d-none');
  })

  var currentURL = new URL(window.location.href);
  var keywordValue = currentURL.searchParams.get("keyword");
  if (keywordValue) {
    $(".icon_clear").removeClass('d-none');
  } else {
    $(".icon_clear").addClass('d-none');
  }

  $(".js-input-keyword").keyup(function(event) {
    if ($(this).val().length > 0) {
      $(".icon_clear").removeClass('d-none');
    } else {
      $(".icon_clear").addClass('d-none');
    }
  });
});